import { combineEpics } from "redux-observable";
import { epicGameTrackingShopBackToOffers } from "./epics/epicGameTrackingShopBackToOffers";
import { epicGameTrackingShopCheckout } from "./epics/epicGameTrackingShopCheckout";
import { epicGameTrackingShopClick } from "./epics/epicGameTrackingShopClick";
import { epicGameTrackingShopPackageSelect } from "./epics/epicGameTrackingShopPackageSelect";
import { epicGameTrackingShopPackageShow } from "./epics/epicGameTrackingShopPackageShow";
import { epicGameTrackingShopProviderNavigate } from "./epics/epicGameTrackingShopProviderNavigate";
import { epicGameTrackingShopProviderSelect } from "./epics/epicGameTrackingShopProviderSelect";
import { epicGameTrackingShopQuit } from "./epics/epicGameTrackingShopQuit";
export var epicGameTrackingShop = combineEpics(epicGameTrackingShopClick, epicGameTrackingShopQuit, epicGameTrackingShopBackToOffers, epicGameTrackingShopCheckout, epicGameTrackingShopPackageSelect, epicGameTrackingShopPackageShow, epicGameTrackingShopProviderNavigate, epicGameTrackingShopProviderSelect);



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epicGameTrackingShop.ts
// module id = 1875
// module chunks = 3